import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import logo from '../assets/cclogo.png';
import { MdLogout } from "react-icons/md";
import { FaDiscord } from 'react-icons/fa';

const handleLogout = () => {

    localStorage.clear();
    // Add your logout logic here
    console.log('Logout button clicked');
};

const TopBar = () => {
    let discordName = null;
    try {
        const userData = JSON.parse(localStorage.getItem('data'));
        if (Array.isArray(userData) && userData.length > 0 && userData[0].discordGlobalName) {
            discordName = userData[0].discordGlobalName;
        }
    } catch (e) {
        discordName = null;
        console.log(e)
    }

    return (
        <AppBar position="static" sx={{ backgroundColor: '#333' }}>
            <Toolbar>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                    <img src={logo} alt="Calico County Logo" style={{ width: '40px', height: '40px', marginRight: '10px' }} />
                    Calico County Core
                </Typography>
                <Stack direction="row" spacing={2}>
                    {discordName && (
                        <span style={{ display: 'flex', alignItems: 'center', color: '#fff' }}>
                            <FaDiscord style={{ marginRight: 6, fontSize: 22 }} />
                            <span style={{ fontWeight: 500 }}>{discordName}</span>
                        </span>
                    )}
                    <Button
                        color="inherit"
                        onClick={handleLogout}
                        href={`${import.meta.env.VITE_REACT_API_URL}/auth/logout`}
                        startIcon={<MdLogout />}
                    >
                        Logout
                    </Button>
                </Stack>
            </Toolbar>
        </AppBar>
    );
};

export default TopBar;
